import React from "react";
import * as Icons from "lucide-react";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { services, whatYouGet, images } from "../mock";
import { Button } from "../components/ui/button";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

export default function Services() {
  return (
    <main>
      <PageHero
        eyebrow="Our Services"
        title="Vending solutions built for every kind of workplace"
        subtitle="From corporate offices to busy warehouses, we design, install and maintain a machine that fits your space and your people — completely free for qualifying sites."
      />

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Box;
              return (
                <Reveal key={s.title} delay={i * 60}>
                  <div className="group h-full rounded-2xl border border-gold/20 bg-white p-7 hover:border-gold hover:shadow-xl transition-all duration-300">
                    <span className="grid place-items-center h-12 w-12 rounded-xl bg-ink text-gold group-hover:bg-gold group-hover:text-ink transition-colors">
                      <Icon size={22} />
                    </span>
                    <h3 className="mt-5 font-display text-lg text-ink">{s.title}</h3>
                    <p className="mt-2 text-[15px] text-muted-foreground leading-relaxed">{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-gold-soft/40 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="rounded-2xl overflow-hidden shadow-2xl ring-1 ring-gold/20">
              <img src={images.machineWall} alt="Vending machine" className="w-full h-[420px] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="font-display text-3xl sm:text-4xl text-ink">Everything included, nothing hidden</h2>
            <p className="mt-4 text-lg text-muted-foreground">{whatYouGet.subtitle}</p>
            <ul className="mt-6 space-y-3">
              {whatYouGet.features.map((f) => (
                <li key={f.title} className="flex items-start gap-3">
                  <span className="grid place-items-center h-6 w-6 rounded-full bg-gold/20 text-gold-dark shrink-0 mt-0.5">
                    <Check size={14} />
                  </span>
                  <span className="text-[15px] text-ink"><span className="font-semibold">{f.title}.</span> <span className="text-muted-foreground">{f.desc}</span></span>
                </li>
              ))}
            </ul>
            <Link to="/contact">
              <Button className="mt-7 h-12 px-7 rounded-full bg-ink hover:bg-gold hover:text-ink text-white font-semibold group">
                Book a Free Site Visit <ArrowRight size={17} className="ml-1.5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
